import React, { useCallback, useEffect } from "react";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import Loading from "../Components/Loading";
import Layout from "../Layout";
import Contrato from "../Pages/Contrato";
import Home from "../Pages/Home";
import Segurado from "../Pages/Segurado";
import { buscarDadosCliente } from "../Store/Actions/API/authActions"

import { useKeycloak } from "@react-keycloak/web";

const PrivateRoute = ({ component: Component, ...rest }) => {

  const { keycloak: { authenticated } } = useKeycloak();

  return (
    <Route
      {...rest}
      render={(props) => {
        if (!authenticated) {
          return process.env.REACT_APP_CONTA_URL;
        }
        return <Component {...props} />;
      }}
    />
  );
};



const Router = () => {

  const {keycloak: { authenticated }} = useKeycloak()
  const initialRender = useCallback(() => {
    if(authenticated)
      buscarDadosCliente()
  }, [authenticated]);

  useEffect(() => {
    initialRender();
  }, [initialRender]);

  return (
      <BrowserRouter>
        <Switch>
          <Route exact path="/" component={() => <Loading zIndex2={true}/>} />
          <PrivateRoute exact path="/contrato" component={Contrato} />
          <Layout>
            <PrivateRoute exact path="/home" component={Home} />
            <PrivateRoute exact path="/segurado/:cpf" component={Segurado} />
          </Layout>
        </Switch>
      </BrowserRouter>
  );
};

export default Router;
